import React, { useState } from "react";
import { Button, Col, FormControl, FormGroup, Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import { AiOutlineMail } from "react-icons/ai";
import Config from "../config.json";
import ContactImage from "../Images/contact us.jpg";
import ContactImage2 from "../Images/cantact us 2.png";
import eitaa from "../Images/eitaa.svg";
import { useContactUs } from "../lib/hooks";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | تماس با ما",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const Contact = () => {
  const [fullName, setFullName] = useState("");
  const [contactBody, setContactBody] = useState("");
  const [email, setEmail] = useState("");
  const [contactTitle, setContactTitle] = useState("");

  const [errors, setErrors] = useState({
    fullName: false,
    contactTitle: false,
    email: false,
    contactBody: false,
  });

  const sendMessage = useContactUs({
    fullName,
    email,
    contactTitle,
    contactBody,
  });

  const isValidEmail = email => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSendMessage = () => {
    let newErrors = {
      fullName: fullName.trim() === "",
      contactTitle: contactTitle.trim() === "",
      email: email.trim() === "" || !isValidEmail(email),
      contactBody: contactBody.trim() === "",
    };
    setErrors(newErrors);
    const hasError = Object.values(newErrors).some(error => error);
    if (!hasError) {
      sendMessage();
    }
  };

  return (
    <DocumentMeta {...page_meta}>
      <section className="hero-sample">
        <div className="hero-sample-right">
          <h1>ارتباط با ما</h1>
          <p>
            لطفاً نظرات و پرسش‌های خود را از طریق فرم یا اطلاعات تماس با ما در
            میان بگذارید
          </p>
          <a href="#contact-sections" className="hero-sample-btn">
            شروع کنید
          </a>
        </div>
        <div className="hero-sample-left hero-sample-left-contact">
          <img src={ContactImage} alt="cantact-us" />
        </div>
      </section>

      <Row
        className="mx-0 text-right justify-content-center w-100 d-flex flex-column-reverse flex-md-row"
        style={{ padding: "50px 20px" }}
        id="contact-sections">
        <Col sm={12} md={6} className="cantact-us-form-container px-4">
          <Row className="mx-0">
            <FormGroup className="w-100 cantact-us-form-group">
              <label>
                عنوان پیام<span className="text-danger">*</span>
              </label>
              <FormControl
                name="title"
                placeholder="عنوان پیام خود را وارد کنید"
                onChange={e => {
                  setContactTitle(e.target.value);
                  if (e.target.value.trim() !== "") {
                    setErrors(prev => ({ ...prev, contactTitle: false }));
                  }
                }}
                isInvalid={errors.contactTitle}
              />
            </FormGroup>
          </Row>
          <Row className="mx-0">
            <FormGroup className="w-100 cantact-us-form-group">
              <label>نام و نام خانوادگی:</label>
              <FormControl
                name="fullName"
                placeholder="نام خود را وارد کنید"
                onChange={e => {
                  setFullName(e.target.value);
                  if (e.target.value.trim() !== "") {
                    setErrors(prev => ({ ...prev, fullName: false }));
                  }
                }}
                isInvalid={errors.fullName}
              />
            </FormGroup>
          </Row>
          <Row className="mx-0">
            <FormGroup className="w-100 cantact-us-form-group">
              <label>
                پست الکترونیکی <span className="text-danger">*</span>
              </label>
              <FormControl
                name="email"
                placeholder="پست الکترونیکی خود را وارد کنید"
                onChange={e => {
                  setEmail(e.target.value);
                  if (
                    e.target.value.trim() !== "" &&
                    isValidEmail(e.target.value)
                  ) {
                    setErrors(prev => ({ ...prev, email: false }));
                  }
                }}
                isInvalid={errors.email}
              />
            </FormGroup>
          </Row>
          <Row className="mx-0">
            <FormGroup className="w-100 cantact-us-form-group">
              <label>
                پیام <span className="text-danger">*</span>
              </label>
              <FormControl
                name="body"
                as="textarea"
                placeholder="پیام خود را وارد کنید"
                rows="5"
                onChange={e => {
                  setContactBody(e.target.value);
                  if (e.target.value.trim() !== "") {
                    setErrors(prev => ({ ...prev, contactBody: false }));
                  }
                }}
                isInvalid={errors.contactBody}
              />
            </FormGroup>
          </Row>
          <Row className="mx-0 justify-content-center">
            <Button
              bsPrefix="cantact-us-form-button"
              onClick={handleSendMessage}>
              ارسال
            </Button>
          </Row>
        </Col>
        <hr className="vertical-hr d-none d-md-block" />
        <Col className="px-0" sm={12} md={5}>
          <Row className="mx-0 cantact-us-hero2">
            <div className="cantact-us-hero2-right">
              <h5 className="cantact-us-hero2-title">اطلاعات تماس</h5>
              <div className="cantact-us-hero2-call">
                <img src={eitaa} width="30px" alt="Eitaa messenger icon" />
                <p>۰۹۳۳۷۳۶۲۹۲۳</p>
              </div>
              <div className="cantact-us-hero2-call">
                <AiOutlineMail
                  size={30}
                  className="cantact-us-hero2-icon-email"
                />
                <p>info@pajoohyar.ir</p>
              </div>
            </div>
            <div className="cantact-us-hero2-left">
              <img
                src={ContactImage2}
                className="cantact-us-hero2-img"
                alt="cantact-us"
              />
            </div>
          </Row>
          <Row className="mx-0" style={{ padding: "30px 0" }}>
            <iframe
              src="https://balad.ir/embed?p=5aHmiJte2RW52e"
              title="مشاهده «معاونت تهران مرکز تحقیقات کامپیوتری علوم اسلامی» روی نقشه بلد"
              width="100%"
              height="300"
              frameBorder="0"
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"></iframe>
          </Row>
        </Col>
      </Row>
    </DocumentMeta>
  );
};

export default Contact;
